import { render, staticRenderFns } from "./tabItemCampaigns.vue?vue&type=template&id=925462a6"
import script from "./tabItemCampaigns.vue?vue&type=script&lang=js"
export * from "./tabItemCampaigns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports